import { Form } from 'antd';
import React from 'react';

import AddressSearch, { AddressData } from '../Fields/AddressSearch';

interface AddressSearchFormItemProps {
    name: string;
    onSelect: (value: AddressData) => void;
    style?: React.CSSProperties;
    value?: string | null;
    required?: boolean;
}

const AddressSearchFormItem: React.FC<AddressSearchFormItemProps> = ({ name, onSelect, style, value, required }) => {
    return (
        <Form.Item name={[name, `street`]} noStyle rules={[{ required: required, message: 'Address is required' }]}>
            <AddressSearch onSelect={onSelect} style={style} value={value} />
        </Form.Item>
    );
};

export default React.memo(AddressSearchFormItem);
